import get from 'lodash/get';
import React from 'react'
import { useTranslation } from 'react-i18next';
import HistoryBlock, { processHistory } from './HistoryBlock';

const HistoryEnabled = ({device}) => {
  const { t } = useTranslation();

  return (
    <HistoryBlock
      title={t("devices.EnabledHistory")}
      data={
        processHistory("enabled")(get(device, 'history.enabled'))}
      cloumnTitle="Enable"
      cloumnAccessor={"enabled"}
    />
   );
}

export default HistoryEnabled;